import React from "react";

export default function CustomiseSection() {
  
  const handleContactClick = () => {
    // Scroll to contact section or navigate to contact page
    const contactSection = document.getElementById("contact");
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: "smooth" });
    } else {
      window.location.href = "/contact"; // Fallback URL
    }
  };

  return (
    <section className="cust-section">
      <div className="cust-container">
        <div className="cust-wrapper">
          
          {/* --- Left Column: Visual Composition --- */}
          <div className="cust-visual-col">
            <div className="cust-composition">
              {/* 1. Main Product Image (Finished Work) */}
              <div className="cust-img-card main-img">
                <img 
                  src="images/cust1.webp" 
                  alt="Finished Embroidery" 
                />
              </div>

              {/* 2. Secondary Image (The 'Sketch' or Process) */}
              {/* <div className="cust-img-card sub-img">
                <img 
                  src="images/cust2.webp" 
                  alt="Design Process" 
                />
              </div> */}

              {/* 3. Decorative Floating Elements */}
              <div className="cust-decor-circle"></div>
              
              {/* 4. Rotating Text Badge */}
              <div className="cust-badge">
                <svg viewBox="0 0 100 100" width="100" height="100">
                  <defs>
                    <path id="circlePath" d="M 50, 50 m -37, 0 a 37,37 0 1,1 74,0 a 37,37 0 1,1 -74,0" />
                  </defs>
                  <text fontSize="13.5" fontWeight="bold" letterSpacing="2">
                    <textPath xlinkHref="#circlePath" fill="currentColor">
                      CUSTOMISE • PRODUCTS •
                    </textPath>
                  </text>
                </svg>
                <div className="cust-badge-center">★</div>
              </div>
            </div>
          </div>

          {/* --- Right Column: Content --- */}
          <div className="cust-content-col">
            <span className="cust-tagline">CUSTOM MADE FOR YOU
</span>
            
            <h2 className="cust-heading">
              Customize Your <br />
              <span className="cust-script">Product,</span>Your Way
            </h2>
            
            <p className="cust-desc">
              Have a memory you want to preserve or an idea waiting to be brought to life?
            From wedding moments and portraits to meaningful gifts, we work closely with you
            to craft personalized embroidery that feels truly yours.

            </p>

            <ul className="cust-features">
              <li><span>✦</span> One-on-One Design Discussion  </li>
              <li><span>✦</span> Premium Threads & Quality Fabrics  </li>
              <li><span>✦</span> Handcrafted with Care & Precision</li>
            </ul>

            <button className="cust-cta-btn" onClick={handleContactClick}>
              Start Your Custom Order
              <span className="arrow">→</span>
            </button>
          </div>

        </div>
      </div>
    </section>
  );
}